import { ColorPicker, ColorPickerProps } from 'antd';
import React from 'react';
interface Props {
  colorPickerProps: ColorPickerProps;
}
const CustomColorPicker: React.FC<Props> = ({ colorPickerProps }) => {
  return (
    <div>
      <ColorPicker {...colorPickerProps} size="large" />
    </div>
  );
};
export default CustomColorPicker;
